import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { isNewPrescriptionAndUpload } from '../../../utils/is-new-prescription-upload.js';
import { SummaryTitle } from '../SummaryTitle/SummaryTitle.js';
import PrescriptionSummaryColumn from './PrescriptionSummaryColumn/PrescriptionSummaryColumn.js';

const PrescriptionSummary = ({ parameters , right , left , labels , prescriptionType ,  })=>{
    if (CommerceToolsApi.isNewPrescription(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType)) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "prescription-summary"
        }, (Object.keys(right).length > 0 || Object.keys(left).length > 0) && /*#__PURE__*/ React.createElement(React.Fragment, null, labels.prescriptionTitle && /*#__PURE__*/ React.createElement(SummaryTitle, null, labels.prescriptionTitle), /*#__PURE__*/ React.createElement("div", {
            className: "glasses-configurator-footer-prescription",
            "data-t": "prescription-summary"
        }, Object.keys(right).length > 0 && /*#__PURE__*/ React.createElement(PrescriptionSummaryColumn, {
            title: labels.rightEye,
            fields: right,
            parameters: parameters,
            prescriptionType: prescriptionType,
            labels: labels
        }), Object.keys(left).length > 0 && /*#__PURE__*/ React.createElement(PrescriptionSummaryColumn, {
            title: labels.leftEye,
            fields: left,
            parameters: parameters,
            prescriptionType: prescriptionType,
            labels: labels
        }))));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "glasses-configurator-footer-prescription",
        "data-t": "prescription-summary"
    }, (!CommerceToolsApi.isNewPrescription(prescriptionType) || !isNewPrescriptionAndUpload(prescriptionType)) && labels.prescriptionTitle && /*#__PURE__*/ React.createElement(PrescriptionSummaryColumn, {
        title: labels.prescriptionTitle,
        labels: labels,
        prescriptionType: prescriptionType
    }));
};

export { PrescriptionSummary as default };
//# sourceMappingURL=PrescriptionSummary.js.map
